/**
 * Configuration for `NotificationSettingsService`.
 *
 * Only the platform shell provides this. The carrier binds it to
 * `TOKENS.NotificationSettingsServiceConfig` from its own per-stage
 * environment, so plugins never supply a base path and never call an
 * initializer.
 */
export interface NotificationSettingsConfig {
  /**
   * Base URL of the notification API, with or without a trailing slash.
   *
   * The service normalizes the value before it builds a request path, so
   * `https://host/v1` and `https://host/v1/` behave the same.
   */
  basePath: string;
}
